module.exports = __webpack_public_path__ + "static/media/bx1.a4a25b42.png";